export default {
  data: {
    dealersPrice: [
      { dealer: { id: 5623, name: 'Dealer Top Ryde' }, price: 56184.0 },
      { dealer: { id: 5624, name: 'Dealer Rhodes' }, price: 57184.0 },
      { dealer: { id: 5624, name: 'Dealer Sydney CBD' }, price: 58184.0 }
    ]
  }
};
